import { render, staticRenderFns } from "./PackageManagement.vue?vue&type=template&id=0e013d97"
import script from "./PackageManagement.vue?vue&type=script&lang=js"
export * from "./PackageManagement.vue?vue&type=script&lang=js"
import style0 from "./PackageManagement.vue?vue&type=style&index=0&id=0e013d97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports